import React from 'react';
import moment from 'moment';
import { createStyleSheet } from '../../../utils';
import { useStyleSheet } from '../../../hooks';
import { View } from '../../View';
import { Divider } from '../../Divider';
import { Text } from '../../Text';
export const Header = ({ date }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: styles.header },
        React.createElement(Divider, { type: 'horizontal', style: styles.divider }),
        React.createElement(View, { style: styles.headerTitleWrapper },
            React.createElement(Text, { type: 'body', size: 'sm', weight: 'regular', style: styles.headerTitle }, moment(date).calendar(null, {
                sameDay: '[Today]',
                lastDay: '[Yesterday]',
                lastWeek: 'dddd, MMMM Do',
                sameElse: 'dddd, MMMM Do'
            }))),
        React.createElement(Divider, { type: 'horizontal', style: styles.divider })));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    header: {
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        paddingVertical: size.C,
        paddingLeft: size.E
    },
    headerTitle: {
        color: color.invert2.p56
    },
    headerTitleWrapper: {
        paddingVertical: size.B,
        paddingHorizontal: size.E,
        borderWidth: 1,
        borderColor: color.invert2.p4,
        borderRadius: 9999
    },
    divider: { flex: 1, alignSelf: 'center' }
}));
//# sourceMappingURL=Header.js.map